import cx from 'classnames';
import { h } from 'preact';

import { DEMOCRAT, LIBERTARIAN, NEUTRAL, REPUBLICAN, TIE } from '../colors';

function MapLegend({ candidates, includesNoResult, includesTie }) {


  return (
    <div class="results-map__legend t-sans">
      <p class="results-map__legend-title">Currently in the lead</p>
      <div class="results-map__legend-items">
        {candidates.map(candidate => {
          return (
            <div class="results-map__legend-item">
              <span
                class={cx(
                  'circle-pill',
                  `pill--${candidate.party.slice(0, 3).toLowerCase()}`
                )}
              />{' '}
              <p class="results-map__legend-label">
                {candidate.name.split(' ')
                .pop()
                .trim()}
              </p>
              <span
                class={cx(
                  'circle-pill',
                  `pill--${candidate.party.slice(0, 3).toLowerCase()}-lean`
                )}
              />{' '}
              <p class="results-map__legend-label">
                {candidate.name.split(' ')
                .pop()
                .trim()} by less than 10%
              </p>
            </div>
          );
        })}
        {includesTie && (
          <div class="results-map__legend-item">
            <span class="circle-pill" style={{ backgroundColor: TIE }} />{' '}
            <p class="results-map__legend-label">Tied</p>
          </div>
        )}
        {includesNoResult && (
          <div class="results-map__legend-item">
            <span class="circle-pill" style={{ backgroundColor: NEUTRAL }} />{' '}
            <p class="results-map__legend-label">No votes</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default MapLegend;